import React from 'react';
import { Card, Form } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import { updateQueryStringOnFieldChange } from '@components/Filters/Filters';
import { countryApi } from '@reducers/geo';

export const CoverageFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const countries = countryApi.useGetForSelectQuery();

  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Search form</Card.Header>
      <Card.Body>
        <Formik
          enableReinitialize
          initialValues={{
            country: searchParams.get('country') || '',
          }}
          onSubmit={() => {}}
        >
          {({ handleChange, handleBlur, values }) => (
            <Form>
              <Form.Label>Country</Form.Label>
              <Form.Select
                className="mb-3"
                name="country"
                size="sm"
                value={values.country}
                onChange={(e) => {
                  handleChange(e);
                  updateQueryStringOnFieldChange(e, {
                    searchParams,
                    setSearchParams,
                  });
                }}
                onBlur={handleBlur}
                disabled={countries.isLoading}
              >
                <option value="">
                  {countries.isLoading ? 'Loading...' : 'Select country'}
                </option>
                {!countries.isLoading &&
                !countries.isError &&
                countries.data.length > 0 ? (
                  <>
                    {countries.data.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.name}
                      </option>
                    ))}
                  </>
                ) : null}
              </Form.Select>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};
